import React from 'react';
import {TopAppBar} from '../../../components/Layout/TopAppBar';
import {useUserBalance} from '../../../hooks/user';

export const TopAppBarContainer: React.FC = () => {
  const {balance: userBalance} = useUserBalance();
  return <TopAppBar balance={userBalance} />;
};
